import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./mediaQuerys.css";
import AltusApp from "./AltusApp";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AltusApp />
  </React.StrictMode>
);
